import CurrentGroup from '@/models/CurrentGroup'
import Group from '@/models/Group'
import GroupSession from '../../models/GroupSession'
import api from '@/services/api'

export default {
  namespaced: true,
  state: {
    currentGroup: null,
    members: [],
    calendar: {
      events: {},
      categories: {},
      eventDetails: {}
    }
  },

  getters: {},

  mutations: {
    setCurrentGroup(state, group) {
      state.currentGroup = group
    },
    setCalendarEvents(state, events) {
      state.calendar.events = events
    },
    setCalendarCategories(state, categories) {
      state.calendar.categories = categories
    },
    setCalendarEventDetails(state, event) {
      state.calendar.eventDetails = event
    }
  },

  actions: {
    getCurrentGroup({ commit }) {
      return CurrentGroup.include(
        'members',
        'values',
        'cover',
        'current_session.video.resource.cover'
      )
        .first()
        .then(res => {
          res.current_session = new GroupSession(res.current_session)
          commit('setCurrentGroup', new Group(res))
        })
    },

    viewGroup({ commit }, slug) {
      return Group.include('members', 'values', 'cover')
        .$find(slug)
        .then(group => {
          commit('setCurrentGroup', group)
        })
    },
    getCalendarCategories({ commit, state }) {
      return new Promise(resolve => {
        api
          .get(`groups/${state.currentGroup.id}/event-categories`)
          .then(async ({ data }) => {
            await commit('setCalendarCategories', data.data)
            resolve()
          })
      })
    },
    getCalendarEvents({ commit, state }) {
      return new Promise((resolve, reject) => {
        api
          .get(`groups/${state.currentGroup.id}/events`)
          .then(async ({ data }) => {
            await commit('setCalendarEvents', data.data)
            resolve()
          })
          .catch(({ response }) => {
            if (response.data && response.data.errors) {
              reject(response.data.errors)
            }
          })
      })
    },
    getCalendarSingleEvent({ state, commit }, eventId) {
      return new Promise(resolve => {
        api
          .get(`groups/${state.currentGroup.id}/events/${eventId}`)
          .then(async ({ data }) => {
            await commit('setCalendarEventDetails', data.data)
            resolve(data.data)
          })
      })
    },
    updateCalendarCategories({ state }, category) {
      return new Promise((resolve, reject) => {
        api
          .put(
            `groups/${state.currentGroup.id}/event-categories/${category.id}`,
            category
          )
          .then(() => {
            resolve()
          })
          .catch(({ response }) => {
            if (response.data && response.data.errors) {
              reject(response.data.errors)
            }
          })
      })
    },
    updateCalendarEvent({ state }, event) {
      return new Promise((resolve, reject) => {
        api
          .put(`groups/${state.currentGroup.id}/events/${event.id}`, event)
          .then(() => {
            resolve()
          })
          .catch(({ response }) => {
            if (response.data && response.data.errors) {
              reject(response.data.errors)
            }
          })
      })
    },
    postCalendarCategories({ state }, category) {
      return new Promise((resolve, reject) => {
        api
          .post(`groups/${state.currentGroup.id}/event-categories`, category)
          .then(() => {
            resolve()
          })
          .catch(({ response }) => {
            if (response.data && response.data.errors) {
              reject(response.data.errors)
            }
          })
      })
    },
    postCalendarEvent({ state }, event) {
      return new Promise((resolve, reject) => {
        api
          .post(`groups/${state.currentGroup.id}/events`, event)
          .then(() => {
            resolve()
          })
          .catch(({ response }) => {
            if (response.data && response.data.errors) {
              reject(response.data.errors)
            }
          })
      })
    },
    deleteCalendarEvent({ state }, eventId) {
      return new Promise((resolve, reject) => {
        api
          .delete(`groups/${state.currentGroup.id}/events/${eventId}`)
          .then(async () => {
            resolve()
          })
          .catch(({ response }) => {
            if (response.data && response.data.errors) {
              reject(response.data.errors)
            }
          })
      })
    },
    deleteCalendarCategories({ state }, category) {
      return new Promise((resolve, reject) => {
        api
          .delete(
            `groups/${state.currentGroup.id}/event-categories/${category.id}`
          )
          .then(() => {
            resolve()
          })
          .catch(({ response }) => {
            if (response.data && response.data.errors) {
              reject(response.data.errors)
            }
          })
      })
    }
  }
}
